import React, { useMemo } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';
import CurrencyInput from 'react-currency-input';
import { customStylesSm, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { formatCurrency } from '../utils';

export default function ResumoAtivo(props) {
  var dados = props.dados;
  var saldoFinanciarLiquido = props.saldoFinanciarLiquido !== undefined
    ? props.saldoFinanciarLiquido
    : (dados ? (dados.saldo_financiar || 0) : 0);
  var valorVendaEditado = props.valorVendaEditado || 0;
  var onValorVendaChange = props.onValorVendaChange;
  var dataVenda = props.dataVenda || '';
  var onDataVendaChange = props.onDataVendaChange;
  var condicoesAtivas = !!props.condicoesAtivas;
  var tabelaOptions = props.tabelaOptions || [];
  var tabelaSelecionada = props.tabelaSelecionada || null;
  var onTrocarTabela = props.onTrocarTabela;
  var isLoading = !!props.isLoading;

  var selectStyles = useMemo(function() {
    return Object.assign({}, customStylesSm, {
      menuPortal: function(b) { return Object.assign({}, b, { zIndex: 99999 }); },
    });
  }, []);

  if (!dados) return null;

  return (
    <Card className="mb-2">
      <Card.Body className="py-2">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="mb-0 text-primary"><strong>Resumo do Ativo</strong></h6>
        </div>

        {/* Tabela selector + identificação */}
        <Row className="align-items-end mb-2">
          <Col md={4} xs={12}>
            <Form.Label className="small mb-1">Tabela de Preço</Form.Label>
            <Select
              placeholder="Selecione..."
              options={tabelaOptions}
              value={tabelaSelecionada}
              onChange={onTrocarTabela}
              styles={selectStyles}
              components={{ DropdownIndicator: DropdownIndicator }}
              isLoading={isLoading}
              menuPortalTarget={document.body}
              menuPosition="fixed"
            />
          </Col>
          <Col md={2} xs={6} className="text-center mt-2 mt-md-0">
            <small className="text-muted d-block">Quadra</small>
            <strong>{dados.mapa1 || '-'}</strong>
          </Col>
          <Col md={2} xs={6} className="text-center mt-2 mt-md-0">
            <small className="text-muted d-block">Lote</small>
            <strong>{dados.mapa2 || '-'}</strong>
          </Col>
          <Col md={2} xs={6} className="text-center mt-2 mt-md-0">
            <small className="text-muted d-block">Prazo Máx.</small>
            <strong>{dados.qtd_max_parcelas || '-'} parcelas</strong>
          </Col>
          <Col md={2} xs={6} className="text-center mt-2 mt-md-0">
            <small className="text-muted d-block">Tabela</small>
            <strong>{dados.codigo_tabela || '-'}</strong>
          </Col>
        </Row>

        {/* Valores principais — tudo em uma linha em md+. Mobile (xs) usa 6/6 para
            empilhar de 2 em 2 sem deixar campos muito estreitos. */}
        <div className="rounded p-2 mb-2" style={{ background: '#f8f9fa', border: '1px solid #e9ecef' }}>
          <Row className="align-items-end">
            <Col xs={6} md={2}>
              <small className="text-muted d-block">Valor à Vista</small>
              <strong>R$ {formatCurrency(dados.valor_a_vista)}</strong>
            </Col>
            <Col xs={6} md={2}>
              <small className="text-muted d-block mb-1">Valor de Venda</small>
              <CurrencyInput
                className="form-control form-control-sm"
                value={valorVendaEditado}
                decimalSeparator=","
                thousandSeparator="."
                prefix="R$ "
                onChangeEvent={function(e, masked, fv) { if (onValorVendaChange) onValorVendaChange(fv); }}
                disabled={condicoesAtivas}
              />
            </Col>
            <Col xs={6} md={2} className="mt-2 mt-md-0">
              <small className="text-muted d-block mb-1">Data Venda</small>
              <Form.Control
                size="sm"
                type="date"
                value={dataVenda}
                onChange={function(e) { if (onDataVendaChange) onDataVendaChange(e.target.value); }}
              />
            </Col>
            <Col xs={6} md={2} className="mt-2 mt-md-0">
              <small className="text-muted d-block">Sinal (Revo)</small>
              <span>R$ {formatCurrency(dados.entrada_imobiliaria)}</span>
            </Col>
            <Col xs={6} md={2} className="mt-2 mt-md-0">
              <small className="text-muted d-block">Sinal (Setpar)</small>
              <span>R$ {formatCurrency(dados.entrada_incorporadora)}</span>
            </Col>
            <Col xs={6} md={2} className="mt-2 mt-md-0">
              <small className="text-muted d-block">Saldo a Financiar</small>
              <strong className="text-success">R$ {formatCurrency(saldoFinanciarLiquido)}</strong>
            </Col>
          </Row>
        </div>
      </Card.Body>
    </Card>
  );
}
